export default class TenantConstants {
  static readonly AppserviceEmptyWarn = 'Appservice plan should not be empty';
  static readonly TargetFarmIdEmptyWarn = 'Target FarmId should be selected';
  static readonly TenantMoved = 'Tenant Moved Successfully!';
}
